import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        gcTime: 1000 * 60 * 60 * 24, // 24 hours
        refetchInterval: 1000 * 60 * 15, // 15 minutes
        staleTime: 1000 * 60 * 15, // 15 minutes
        refetchOnWindowFocus: false,
        // refetchOnMount: true,
        // retry: true,
        // refetchOnReconnect: false,
        // networkMode: 'online',
      },
    },
  });